import React, { useState } from "react";
import styles from "./style.module.scss";
import { Images } from "assets";
import classNames from "classnames";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { routeConstant } from "shared/routes/routesConstant";
import { useNavigate } from "react-router-dom";

let slider = [
  { id: 1, img: Images.KeywordsSliderImage },
  {
    id: 2,
    img: Images.LeadershipSliderImage,
    navigation: routeConstant.leadershipBoard.path,
  },
  {
    id: 3,
    img: Images.TermsSliderImage,
    navigation: routeConstant.termsAndCondition.path,
  },
  {
    id: 4,
    img: Images.PolicySliderImage,
    navigation: routeConstant.privacyPolicy.path,
  },
];

function OtherDifferentControlsProjectHead() {
  const navigate = useNavigate();
  const [sliders, setSliders] = useState<any>(slider);

  const handleChangeDirection = () => {
    let temp = [...sliders];
    if (temp.length === 0) return temp;
    const firstElement = temp.shift();
    temp.push(firstElement);
    setSliders(temp);
  };

  return (
    <div className={styles.mainContainer}>
      <label className={styles.title}>
        Other Different Controls for Project Head
      </label>
      <label className={styles.subTitle}>
        Different controls which only project head can control or edit, the all
        control for project head are given below:
      </label>

      <div className={styles.sliderContainer}>
        {sliders?.map((itm: any, index: any, arr: any) => {
          return (
            <div
              className={styles.singleCardContainer}
              onClick={() => navigate(itm?.navigation)}
            >
              <img
                src={itm?.img}
                alt="slider-imgs"
                className={classNames(
                  styles.sliderImgs,
                  index !== 0 ? styles.imgBlur : ""
                )}
                style={{
                  zIndex: `${(arr?.length - index) * 10}`,
                  height: `${index !== 0 ? 240 - index * 10 : 260}px`,
                }}
              />
            </div>
          );
        })}
        <div
          className={styles.arrowContainer}
          onClick={() => handleChangeDirection()}
        >
          <KeyboardArrowRightIcon sx={{ color: "white" }} />
        </div>
      </div>
    </div>
  );
}

export default OtherDifferentControlsProjectHead;
